import React, { Component } from "react";
import { Container, Header, Statistic } from "semantic-ui-react";
import PropTypes from "prop-types";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import { CONTACT_ROUTE, BASE_URL } from "../../constants/route.constants";
import { APP_NAME } from "../../constants/resource.constants";
import NavBar from "../../components/NavBar/NavBar";
import Footer from "../../components/Footer/FooterView";

export default class AboutPage extends Component {
  componentDidMount() {
    this.props.history.listen((location, action) => {
      window.scrollTo(0, 0);
    });
  }

  render() {
    return (
      <div>
        <header>
          <NavBar {...this.props} />
        </header>
        <Container>
          <Helmet>
            <title>About Us | {APP_NAME}</title>
            <meta
              name="description"
              content="The about GAA International page, our mission and who we are."
            />
            <link
              rel="canonical"
              href={`${BASE_URL}${window.location.pathname}`}
            />
            <meta property="og:title" content={`About Us | ${APP_NAME}`} />
            <meta
              property="og:description"
              content="The about GAA International page, our mission and who we are."
            />
            <meta
              property="og:image"
              content="https://d3hfkx84ni8spj.cloudfront.net/misc/gaa-intl-lrg.png"
            />
            <meta
              property="og:url"
              content={`${BASE_URL}${window.location.pathname}/`}
            />
            <meta property="og:type" content="website" />
          </Helmet>
          <Container text>
            <Header as="h2">About Us</Header>
            <p>
              At GAA International, we pride ourselves on having the most
              comprehensive and far-reaching list of Gaelic clubs
              internationally. GAA International is not associated with the
              Gaelic Athletic Association, instead, we are an independent site
              which shares a similar vision, to promote Gaelic Games.
            </p>
            <p>
              If you know of a club not on our website please submit the details
              via our <Link to={CONTACT_ROUTE}>contact</Link> page.
            </p>
          </Container>
          <div className="spacer" />
          <Container text textAlign="center">
            <Header as="h2">- Our Mission -</Header>
            <p>To connect people with Gaelic clubs around the world.</p>
            <Statistic.Group widths="three">
              <Statistic color="yellow">
                <Statistic.Value>437</Statistic.Value>
                <Statistic.Label>Clubs</Statistic.Label>
              </Statistic>
              <Statistic color="green">
                <Statistic.Value>50</Statistic.Value>
                <Statistic.Label>Countries</Statistic.Label>
              </Statistic>
              <Statistic color="yellow">
                <Statistic.Value>826</Statistic.Value>
                <Statistic.Label>Teams</Statistic.Label>
              </Statistic>
            </Statistic.Group>
          </Container>
        </Container>
        <Footer />
      </div>
    );
  }
}

AboutPage.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func
  }).isRequired
};



// WEBPACK FOOTER //
// ./src/routes/AboutPage/View.js